import './App.css';
import { useState } from 'react';
import cn from 'classnames'
import { Game } from './components/Game';
import { Start } from './components/Start-screen/Start';

function App() {
  const [enemy , setEnemy ] = useState('')

  return (
    <div className={cn('App')}>

        <Start setEnemy={setEnemy}/>
      <header className="App-header">
      </header>
      <Game enemy ={enemy}/>
        <span></span>
    </div>
  );
}

export default App;
